import script from "./TechnicianProductsReport.vue?vue&type=script&setup=true&lang=js"
export * from "./TechnicianProductsReport.vue?vue&type=script&setup=true&lang=js"

import "./TechnicianProductsReport.vue?vue&type=style&index=0&id=5108be5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5108be5d"]])

export default __exports__